/* tp-gift-card — 礼品卡购买页交互(sections/tp-gift-card.liquid)。
   四步:卡面 → 金额 → 收礼人 → 发送时间;都不预选(店主 10/11 规矩)。填完出最终预览(邮件 / 礼物页)。
   预览模式(页面上没有礼品卡商品)只弹提示,不加购;商品页模式按 卡面|金额 找变体,带收礼人字段加购后去购物车。 */
(function () {
  function init(root) {
    var cfgEl = root.querySelector('[data-tpgc-config]');
    if (!cfgEl) return;
    var cfg; try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var D = {}; cfg.designs.forEach(function (d) { D[d.k] = d; });
    var st = { design: null, amt: null, when: null, logo: null }, finalShown = false, tab = 'mail', logoFile = null, busy = false;
    var esc = function (t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    $('[data-designs]').innerHTML = cfg.designs.map(function (d) {
      return '<button class="tpgc__opt" type="button" data-d="' + d.k + '" aria-pressed="false"><img src="' + d.thumb + '" alt="' + esc(d.label) + ' card design" width="480" height="278" loading="lazy"><span class="tpgc__ol">' + esc(d.label) + '</span></button>';
    }).join('');
    $('[data-amts]').innerHTML = cfg.amounts.map(function (a) {
      return '<button class="tpgc__opt" type="button" data-a="' + a + '" aria-pressed="false"><span class="tpgc__ol">$' + a + '</span><small>' + esc(cfg.hints[a] || '') + '</small></button>';
    }).join('');

    var today = new Date(), pad = function (n) { return String(n).padStart(2, '0'); };
    var iso = function (x) { return x.getFullYear() + '-' + pad(x.getMonth() + 1) + '-' + pad(x.getDate()); };
    $('[data-date]').min = iso(new Date(today.getTime() + 864e5));
    $('[data-date]').max = iso(new Date(today.getTime() + 90 * 864e5));

    var val = function (s) { return ($(s).value || '').trim(); };
    var strong = function (t, c) { var e = document.createElement('span'); e.className = c; e.textContent = t; return e; };
    var emailOk = function () { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(val('[data-email]')); };
    function next() {
      if (!st.design) return [1, 'Pick a card', 1];
      if (!st.amt) return [2, 'Choose an amount', 2];
      if (!val('[data-to]')) return [3, 'Add their name', 3];
      if (!emailOk()) return [3, 'Add their email', 3];
      if (!val('[data-from]')) return [3, 'Add your name', 3];
      if (!st.when) return [4, 'Choose when to send', 4];
      if (st.when === 'date' && !val('[data-date]')) return [4, 'Pick a send date', 4];
      return [5, 'Add to cart', 4];
    }
    function render() {
      var d = st.design ? D[st.design] : null;
      $('[data-fan]').hidden = !!d; $('[data-solo]').hidden = !d; $('[data-cap]').hidden = !!d;
      if (d) { var im = $('[data-solo-img]'); im.src = d.card; im.alt = d.label + ' gift card'; $('.tpgc__gc').style.setProperty('--amt-ink', d.ink); }
      $('[data-solo-amt]').textContent = st.amt ? '$' + st.amt : '';
      $('[data-logobox]').hidden = st.design !== 'business';
      $$('[data-logo-ov]').forEach(function (o) { var on = st.design === 'business' && !!st.logo; o.hidden = !on; if (on) o.querySelector('img').src = st.logo; });
      var to = val('[data-to]'), from = val('[data-from]'), note = val('[data-note]');
      $('[data-tag]').hidden = !(to || from || note);
      $('[data-tag-to]').textContent = to || '—'; $('[data-tag-from]').textContent = from || '—'; $('[data-tag-note]').textContent = note;
      /* 店主 10/25:邮箱不让输两遍,填对格式后在输入框下面加粗回显,最终预览里也加粗,方便一眼核对 */
      var em = val('[data-email]'), eh = $('[data-email-help]');
      if (emailOk()) { eh.textContent = 'We\u2019ll send it to '; eh.appendChild(strong(em, 'tpgc__strong tpgc__echo')); }
      else eh.textContent = 'We\u2019ll send the gift here.';
      $('[data-cnt]').textContent = $('[data-note]').value.length + '/' + $('[data-note]').maxLength;
      $$('[data-designs] .tpgc__opt').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-d') === st.design); });
      $$('[data-amts] .tpgc__opt').forEach(function (b) { b.setAttribute('aria-pressed', +b.getAttribute('data-a') === st.amt); });
      $$('[data-whens] .tpgc__opt').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-w') === st.when); });
      $('[data-datebox]').hidden = st.when !== 'date';
      var n = next(), done = n[0] === 5;
      $('[data-bar-amt]').textContent = st.amt ? '$' + st.amt : 'From $' + cfg.amounts[0];
      $('[data-bar-sum]').textContent = d ? d.label + ' card' : 'Cake gift card';
      $('[data-bar-step]').textContent = done ? 'All set' : 'Step ' + n[0] + ' of 4';
      $('[data-bar-next]').textContent = n[1] + ' ›';
      $('[data-bar]').classList.toggle('is-ready', done);
      $('[data-add]').setAttribute('aria-disabled', !done);
      if (!busy) $('[data-add]').textContent = done ? 'Add to cart · $' + st.amt : 'Add to cart';
      $('[data-mini]').hidden = !d;
      if (d) { $('[data-mini-img]').src = d.thumb; $('[data-mini-amt]').textContent = st.amt ? '$' + st.amt : ''; $('[data-mini]').style.setProperty('--mini-ink', d.ink); }
      renderFinal(done, d, to, from, note);
    }
    function renderFinal(done, d, to, from, note) {
      var f = $('[data-final]'); f.hidden = !done; if (!done) return;
      $$('[data-to-name]').forEach(function (e) { e.textContent = to; });
      $$('[data-from-name]').forEach(function (e) { e.textContent = from; });
      $$('[data-final-card]').forEach(function (e) { e.src = d.card; e.alt = d.label + ' gift card'; });
      $$('[data-final-amt]').forEach(function (e) { e.textContent = '$' + st.amt; });
      $$('[data-final-wrap]').forEach(function (e) { e.style.setProperty('--amt-ink', d.ink); });
      $$('[data-final-amtc]').forEach(function (e) { e.textContent = '$' + st.amt.toFixed(2) + ' CAD'; });
      var sig = note ? note + '  — ' + from : '';
      $('[data-mnote]').textContent = sig; $('[data-pnote]').textContent = sig;
      var when = 'Arrives right after you check out', chip = 'Sends right away';
      if (st.when === 'date') {
        var dt = new Date(val('[data-date]') + 'T12:00:00');
        var nice = dt.toLocaleDateString('en-CA', { weekday: 'short', month: 'short', day: 'numeric' });
        when = 'Arrives the morning of ' + nice; chip = 'Sends ' + nice;
      }
      var mw = $('[data-mwhen]'); mw.textContent = 'To '; mw.appendChild(strong(val('[data-email]'), 'tpgc__strong')); mw.appendChild(document.createTextNode(' \u00b7 ' + when));
      $('[data-checks]').innerHTML = [d.label + ' card', '$' + st.amt, 'To ' + to, 'From ' + from, chip].map(function (t) { return '<li>' + esc(t) + '</li>'; }).join('');
      $$('[data-mock]').forEach(function (m) { m.hidden = m.getAttribute('data-mock') !== tab; });
      $$('.tpgc__tabs button').forEach(function (b) { b.setAttribute('aria-selected', b.getAttribute('data-tab') === tab); });
      if (!finalShown) { finalShown = true; setTimeout(function () { f.scrollIntoView({ behavior: 'smooth', block: 'start' }); }, 250); }
    }
    function go(stepNo) {
      var el = $('[data-step="' + stepNo + '"]'); if (!el) return;
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      el.classList.remove('is-flash'); void el.offsetWidth; el.classList.add('is-flash');
      if (stepNo === 3) {
        var inp = $$('[data-step="3"] input').filter(function (i) { return i.type === 'email' ? !emailOk() : !i.value.trim(); })[0];
        if (inp) setTimeout(function () { inp.focus({ preventScroll: true }); }, 450);
      }
    }
    function toast(t) { var e = $('[data-toast]'); e.textContent = t; e.hidden = false; clearTimeout(e._t); e._t = setTimeout(function () { e.hidden = true; }, 2800); }
    function submit() {
      var n = next();
      if (n[0] !== 5) { go(n[2]); toast(n[1]); return; }
      if (cfg.preview) { toast('Preview only: the gift card goes live after approval.'); return; }
      if (busy) return;
      var d = D[st.design], vid = cfg.variants[d.label + '|' + st.amt];
      if (!vid) { toast('This card isn\u2019t available right now. Please try another.'); return; }
      /* Shopify 礼品卡收礼人字段(与 Dawn 同名):勾选位 + 邮箱 / 名字 / 留言(≤200)/ 发送日 + 时区偏移。
         留言 = 客人的话 + 署名(输入框限 165 + 名字 ≤30,合起来不超 200);署名另存 From,Logo 存为文件属性,卡面另存 _tp_card。 */
      var to = val('[data-to]'), from = val('[data-from]'), note = val('[data-note]');
      var fd = new FormData();
      fd.append('id', vid); fd.append('quantity', '1');
      fd.append('properties[__shopify_send_gift_card_to_recipient]', 'on');
      fd.append('properties[Recipient email]', val('[data-email]'));
      fd.append('properties[Recipient name]', to);
      fd.append('properties[Message]', (note ? note + ' \u2014 ' + from : 'From ' + from).slice(0, 200));
      if (st.when === 'date') fd.append('properties[Send on]', val('[data-date]'));
      fd.append('properties[__shopify_offset]', String(new Date().getTimezoneOffset()));
      fd.append('properties[From]', from);
      /* 下划线开头 = 结账页不显示;回执 / 通知邮件靠它选卡面图(tp-gc-mail-<卡面>-<金额>.jpg) */
      fd.append('properties[_tp_card]', st.design);
      if (st.design === 'business' && logoFile) fd.append('properties[Logo]', logoFile);
      busy = true;
      var btn = $('[data-add]'); btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding\u2026';
      fetch(cfg.addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () { window.location.href = cfg.cartUrl; })
        .catch(function (err) {
          busy = false; btn.removeAttribute('aria-busy'); render();
          toast((err && (err.description || err.message)) || 'Couldn\u2019t add the gift card. Please try again.');
        });
    }

    root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-fan] button, [data-designs] .tpgc__opt'))) { st.design = b.getAttribute('data-d'); render(); return; }
      if ((b = e.target.closest('[data-amts] .tpgc__opt'))) { st.amt = +b.getAttribute('data-a'); render(); return; }
      if ((b = e.target.closest('[data-whens] .tpgc__opt'))) { st.when = b.getAttribute('data-w'); render(); if (st.when === 'date') setTimeout(function () { $('[data-date]').focus(); }, 50); return; }
      if ((b = e.target.closest('.tpgc__tabs button'))) { tab = b.getAttribute('data-tab'); render(); return; }
      if (e.target.closest('[data-mini]')) { $('.tpgc__media').scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
      if (e.target.closest('[data-bar-btn], [data-add]')) { submit(); }
    });
    ['[data-to]', '[data-from]', '[data-email]', '[data-note]', '[data-date]'].forEach(function (s) { $(s).addEventListener('input', render); });
    $('[data-email]').addEventListener('blur', function () { $('[data-email-f]').classList.toggle('is-err', !!val('[data-email]') && !emailOk()); });
    $('[data-logo]').addEventListener('change', function (e) {
      var f = e.target.files && e.target.files[0];
      logoFile = null;
      if (!f) { st.logo = null; render(); return; }
      if (f.size > 5 * 1024 * 1024) { e.target.value = ''; st.logo = null; render(); toast('Please use a logo under 5 MB.'); return; }
      logoFile = f;
      var r = new FileReader(); r.onload = function () { st.logo = r.result; render(); }; r.readAsDataURL(f);
    });
    render();
  }
  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-tpgc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
